import { AxiosResponse } from "axios";
import { API } from "constants/api";
import { ICReportConverted, ICReportData } from "store/slice/Project/icDashboard/icDashboard.types";
import axios from "utils/axios";
import { RequestInfo } from "store/slice/store.types";
import { THeaderConfigIds } from "components/Management/table-config";
import qs from "qs";

export interface ICReportSlice {
    data: ICReportConverted | null;
    error: string | null;
    status: RequestInfo;
    loadedParams: { projectId: string | null; insightId: string | null } | null;
}

interface ICReportServiceResponse {
    data: ICReportData;
}

export const getICReport = (projectId: string | null, insightId: string | null): Promise<ICReportServiceResponse> => {
    if (!projectId || !insightId) {
        return Promise.reject(new Error("Missing proyect_id or insight_id."));
    }

    const project_path = `project_${projectId}/insight_list/insight_${insightId}`;

    return axios.get(API.IC_DASHBOARD.GET(projectId), { params: { project_path } });
};

export const getICReportPPT = (
    projectId: string | null,
    insightId: string | null,
    columns: THeaderConfigIds[] | undefined
): Promise<AxiosResponse<Blob>> => {
    if (!projectId || !insightId) {
        return Promise.reject(new Error("Missing proyect_id or insight_id."));
    }

    const project_path = `project_${projectId}/insight_list/insight_${insightId}`;
    const params = qs.stringify({ project_path, columns }, { arrayFormat: "repeat" });

    return axios.get(`${API.IC_DASHBOARD.GET(projectId)}?${params}`, {
        headers: { Accept: "application/mspowerpoint" },
        responseType: "blob",
    });
};
